module.exports = __webpack_public_path__ + "static/traffic-signal-operations-near-highwayrail-grade-crossings-cdddac0f101dfcde93eacf5bac1dc222.jpg";